import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	securityOidcConfigurationsByCustomerByIdReducers,
	securityOidcConfigurationsByCustomerByIdWatchers
} from './_id';

export const securityOidcConfigurationsByCustomerReducers = combineReducers({
	byId: securityOidcConfigurationsByCustomerByIdReducers
});

export const securityOidcConfigurationsByCustomerWatchers = combineAllWatchers([
	securityOidcConfigurationsByCustomerByIdWatchers
]);
